export const mapArrayToLabelValue = (array: any[], labelProp: string, valueProp: string) => {
  return array
    .map((item) => {
      const label = item[labelProp];
      const value = item[valueProp];

      if ((label === '' || label == null) && typeof value === 'string' && value.trim() !== '') {
        return {
          label: value,
          value: value,
        };
      }

      if ((label === '' || label == null) && (value === '' || value == null)) {
        return null;
      }

      return {
        label,
        value,
      };
    })
    .filter((item) => item !== null);
};

export const mapEntityDescriptionArrayToLabelValue = (array: any[]) =>
  mapArrayToLabelValue(array, "description", "id");
